import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isModalOpen: false,
    modalType: null,
    modalProps: {},
};

const modalSlice = createSlice({
    name: "modals",
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.isModalOpen = true;
            state.modalType = action.payload.modalType;
            state.modalProps = action.payload.modalProps || {};
        },
        closeModal: (state) => {
            state.isModalOpen = false;
            state.modalType = null;
            state.modalProps = {};
        },
    },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
